import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FlatpickrDirective, provideFlatpickrDefaults } from 'angularx-flatpickr';

@Component({
  selector: 'app-time-input-v2',
  templateUrl: './time-input-v2.component.html',
  styleUrls: ['./time-input-v2.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    FlatpickrDirective,
  ],
  providers: [provideFlatpickrDefaults()],
})
export class TimeInputV2Component {
  @Input() label = 'Time';
  @Input() name = 'time';
  @Input() required = false;
  @Input() timeValue = '';
  @Input() format: 12 | 24 = 24;
  @Input() min: string | null = null;
  @Input() disabled = false;

  @Output() timeValueChange = new EventEmitter<string>();
  @Output() timeChanged = new EventEmitter<string>();

  onTimeSelected(value: string): void {
    this.timeValue = value;
    this.timeValueChange.emit(value);
    this.timeChanged.emit(value);
  }

  clearTimeValue(): void {
    this.timeValue = '';
    this.timeValueChange.emit('');
    this.timeChanged.emit('');
  }
}
